"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.productAPISearch.name': 'Wyszukiwanie Produktów i Kategorii',
    'tools.productAPISearch.description': 'Wyszukuje produkty i pobiera kategorie produktów za pomocą integracji SmartShop API',
};
